import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes";
import { HelmetProvider } from "react-helmet-async";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-toastify/dist/ReactToastify.css";
import { LoadScript } from "@react-google-maps/api";
import QueryProvider from "./QueryProvider";
import { ToastContainer } from "react-toastify";
import { TOAST_CONFIG } from "../core/config/Constant";
import useAuthStore from "../core/store/authStore";

function App() {
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={["places", "marker"]}
      loadingElement={<></>}
    >
      <QueryProvider>
        <HelmetProvider>
          <RouterProvider router={router} />
          <ToastContainer {...TOAST_CONFIG} />
        </HelmetProvider>
      </QueryProvider>
    </LoadScript>
  );
}

export default App;
